import { get } from 'lodash';
import { OptionProps } from 'pages/ChartEditorPage/meta/CustomizeOptions';
import * as React from 'react';
import Accordion, { AccordianProps } from 'shared/Accordion';
import { customSelectColors } from 'shared/inputs/CustomSelect';
import { GenericInputProps } from 'shared/types/commonPropTypes';
import useToggle from 'shared/utils/useToggle';
import BuildInputs, { keepWhiteBgMap } from './BuildInputs';

const OpenContainer = (props: AccordianProps) => {
  return <div>{props.children}</div>;
};

interface AccordianWidgetProps extends GenericInputProps {
  accordianClasses?: string;
  open?: boolean;
  children?: React.ReactNode;
}

const AccordionWidget = (props: AccordianWidgetProps) => {
  const { option, open } = props;
  const [isActive, toggleIsActive] = useToggle(option?.custom?.defaultSelection ?? false);
  const styledOptions = option?.options?.map((field) => ({
    ...field,
    className: (field?.type ?? '') in keepWhiteBgMap ? null : 'bg-ev-grey',
    inputClassName: (field?.type ?? '') in keepWhiteBgMap ? 'bg-ev-grey' : '',
    backgroundColor: customSelectColors.grey
  }));
  const section = { ...option, options: styledOptions };
  const Container = open ? OpenContainer : Accordion;

  // Used for unit chart to display number of icons used
  const getSubheader = (option: OptionProps | undefined) => {
    if (option?.isBasedOnSeriesData) {
      const { aggregatedOptions } = props;
      if (aggregatedOptions.series[0].data) {
        let val = aggregatedOptions.series[0].data;
        val = (val || []).map((d: any) => {
          return get(d, option?.id ?? '');
        });
        return (val ?? []).length;
      }
    }
    return '';
  };

  const subheader = getSubheader(option);

  return (
    <Container
      headerText={props.label}
      smallHeaderText={true}
      selected={isActive}
      onClick={() => toggleIsActive()}
      childrenClasses="rounded mx-4 py-2 relative flex-col"
      accordionClasses={`${props.accordianClasses ?? 'bg-white'}`}
      selectedChildren={subheader}
    >
      <BuildInputs section={section} parentPath={props.parentPath} index={props.index} />
      {props.children}
    </Container>
  );
};

export default AccordionWidget;
